export default "__VITE_ASSET__BCQv7znw__"